import React, {Component} from 'react'
import PropTypes from 'prop-types'

import SaveFilterErrorDialogComponent from './SaveFilterErrorDialog.component'

class SaveFilterErrorDialogContainer extends Component {

  handleCloseClick = (evt) => {
    evt.preventDefault()
    this.props.onClose()

    this.props.analytics.propagateEvent({
      eventType: 'click',
      action: 'Save Filter Error Close',
      type: 'Datatable'
    })
  }

  render() {
    const events = {
      handleCloseClick: this.handleCloseClick,
    }
    const {i18n, saveFilterError} = this.props

    return (
      <SaveFilterErrorDialogComponent saveFilterError={saveFilterError} events={events} i18n={i18n} />
    )
  }
}

export default SaveFilterErrorDialogContainer
